export type Breakpoint = (typeof BREAK_POINTS)[number]

/**
 * Ordered breakpoints
 */
export const BREAK_POINTS = ['mobile', 'tablet', 'desktop'] as const

export const BREAK_POINT = Object.fromEntries(BREAK_POINTS.map((breakpoint) => [breakpoint, breakpoint])) as {
  [B in Breakpoint]: B
}

export const BREAK_POINT_RAW_WIDTH = {
  mobile: 768,
  tablet: 1024,
  desktop: 1440
} as const satisfies { [k in Breakpoint]: number }

export const BREAK_POINT_WIDTH: {
  [k in keyof typeof BREAK_POINT_RAW_WIDTH]: `${(typeof BREAK_POINT_RAW_WIDTH)[k]}px`
} = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px'
} as const

export const Z_INDEXES = {
  header: '9001',
  modal: '9002',
  modalBackdrop: '9000',
  loader: '8200',
  alert: '9100'
} as const
